import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';
import {
	NotificationFilterFrequency,
	NotificationFilterType,
	NotificationScheduleType,
} from 'webapp/enums/notifications';

import type { Alert } from 'webapp/models-custom';
import NotificationBase from 'webapp/models-custom/notification/base';

export default class NotificationAlert extends NotificationBase {
	@service('model-manager/alerts')
	declare mmAlertsService: Service.ModelManager.Alerts;

	type = NotificationFilterType.ALERT;
	scheduleType = NotificationScheduleType.ALERT;
	targetObject: Alert;
	typeColor = 'var(--databox-red-500)';
	typeIcon: IconName = 'Alert';
	override canToggle = true;

	override billingFeature = BillingFeature.ALERTS;

	constructor(model: Alert) {
		super();
		this.targetObject = model;
	}

	get title() {
		return this.targetObject.metricSetup?.selectedMetricTitleWithUnit || '';
	}

	get subtitleText() {
		return this.targetObject.sourceObj?.title || '';
	}

	override get subtitleImage() {
		return this.targetObject.sourceObj?.realAvatar || '';
	}

	get isMine() {
		return this.targetObject.isMine;
	}

	get frequency() {
		return [NotificationFilterFrequency.CONDITIONAL];
	}

	get frequencyTooltipTextTop() {
		return this.targetObject.name;
	}

	get createdBy() {
		return this.targetObject.createdBy || null;
	}

	get createdOn() {
		return this.targetObject.created;
	}

	get deliveryTypes() {
		return this.targetObject.deliveryType;
	}

	get emailRecipients() {
		return this.targetObject.userIds;
	}

	get allRecipients() {
		return this.targetObject.mappedRecipients;
	}

	override get isToggleOn() {
		return this.targetObject.isActive;
	}

	delete() {
		// custom logic. if i see a "shared" alert where im not the owner, deleting "my" will just remove myself from the original
		void this.targetObject.deleteAndCatch();
	}

	override toggle() {
		this.mmAlertsService.toggleIsActive(this.targetObject);
	}
}
